import { PropsWithChildren } from 'react'

import { twMerge } from 'tailwind-merge'

import { UseTextStyleProps, useTextStyle } from './useTextStyle'

type TextProps = {
  size?: UseTextStyleProps['size']
  color?: 'white' | 'gray-300' | 'success-300' | 'error-300'
  display?: 'block' | 'inline-block'
  align?: 'left' | 'center' | 'right'
  weight?: UseTextStyleProps['weight']
  underline?: boolean
  className?: string
}

export function Text({
  size = 'base',
  color = undefined,
  display = 'block',
  align = 'left',
  weight = undefined,
  underline = false,
  children = undefined,
  className = '',
}: PropsWithChildren<TextProps>) {
  const { textStyle, weightStyle, underlineStyle } = useTextStyle({
    size,
    weight,
    underline,
  })

  return (
    <div
      className={twMerge(
        `${textStyle} ${weightStyle} ${underlineStyle} text-${align} ${display} ${className}`,
        color && `text-${color}`
      )}
    >
      {children}
    </div>
  )
}
